/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */

import './gw-group-sw-management.scss';
/* eslint-disable import/no-unresolved, import/default */
import gwGroupSwManagementTemplate from './gw-group-sw-management.tpl.html';

export default angular.module('tektelic.gwGroupSwManagement', [])
    .directive('gwGroupTkSwManagement', GwGroupSwManagement)
    .name;

/*@ngInject*/
function GwGroupSwManagement() {
    return {
        restrict: "E",
        scope: true,
        bindToController: {
            entityId: '=',
            isReadOnly: '=',
            position: '='
        },
        controller: GwGroupSwManagementController,
        controllerAs: 'vm',
        templateUrl: gwGroupSwManagementTemplate
    };
}

/*@ngInject*/
function GwGroupSwManagementController($rootScope, $scope, $element, gatewayCommandService, gatewayGroupService, gatewayService, $filter, $translate, $mdMedia, types, toast, $timeout, $q) {

    var vm = this;

    vm.$onInit = function () {
        vm.isInProgress = false;
        vm.gwGroupGateways = [];
        vm.types = types;
        vm.gwGroupGatewaysMap = [];
        vm.components = [];
        vm.selectedComponents = [];
        vm.rowsCount = 0;
        vm.installUpgradeStatusMessage = null;
        vm.sucessMessage = null;
        vm.bspUpgradeInProgress = 0;

        vm.verType = types.software.verType.short.value;
        vm.mode = types.software.mode.swList;

        vm.hasBspUpgrade = false;
        vm.installUpgradeStatusMessage = null;

        vm.query = {
            order: 'mac',
            limit: 15,
            page: 1,
            search: null
        };

        vm.limitOptions =
            [15, 30, 45];

        vm.onReorder = function () {
            updateComponents();
        };

        vm.onPaginate = function () {
            updateComponents();
        };


        vm.upgradeAllGatewaysBsp = upgradeAllGatewaysBsp;

        vm.loading = function () {
            return $rootScope.loading;
        };
    };

    $scope.$on(types.broadcastEvents.GATEWAY_GROUP.loadGwSwVersions, function () {
        if (vm.entityId) {
            reload();
        }
    });

    $scope.$watch('vm.entityId', (newVal) => {
        if (newVal && $scope.selectedTab === vm.position) {
            reload();
        }
    });

    $scope.$watch(function () {
        return $mdMedia('gt-md');
    }, function (isGtMd) {
        vm.isGtMd = isGtMd;
        if (vm.isGtMd) {
            vm.limitOptions = [15, 30, 45];
        } else {
            vm.limitOptions = null;
        }
    });

    function getBspUpgradeStatus(gwData) {
        if (gwData["bspVersion"] === gwData["bspNewVersion"]){
            return {
                "bspUpgradeStatus": "BSP is up to date",
                "hasUpdate": false
            };
        } else {
            return {
                "bspUpgradeStatus": "BSP upgrade is available",
                "hasUpdate": true
            };
        }
    }


    function reload() {
        vm.gwGroupGateways = [];
        vm.gwGroupGatewaysMap = [];


        gatewayService.getAllGatewayGroupGateways(vm.entityId.id).then(
            (gateways) => {
                vm.gwGroupGateways = gateways;
                angular.forEach(gateways, function (gateway) {
                    vm.installUpgradeStatusMessage = null;
                    vm.rowsCount = 0;

                    let gwData = {
                        mac: gateway.mac,
                        gatewayId: gateway.id
                    };
                    vm.gwGroupGatewaysMap.push(gwData)
                })
                updateComponents()
            },
            () => {
            }
        );
    }

    function upgradeAllGatewaysBsp() {
        vm.isInProgress = true
        if (!vm.gwGroupGatewaysMap.filter(g => g['hasUpdate']).length) {
            vm.sucessMessage = "Everything is upgraded."
        }
        vm.gwGroupGatewaysMap.forEach(gatewayData => {
            if (gatewayData.hasUpdate){
                let params = {packageToUpgrade: "tektelic-bsp-version"}
                vm.swComponentsPromise = gatewayCommandService.executeCommand(
                    gatewayData.gatewayId.id,
                    types.softwareCommand.upgradeSoftware.value,
                    params
                    ).then( () => {
                        const isBspUpgrade = true;
                        vm.bspUpgradeInProgress = 120;
                        poolInstallUpgradeStatus(5000, isBspUpgrade, gatewayData.gatewayId.id);
                    })
            }
        });
    }

    function updateComponents() {
        const isAllUpdated = !vm.gwGroupGatewaysMap.filter(g => g['hasUpdate']).length 
        if (isAllUpdated && vm.isInProgress) {
            updateSuccessMessage($translate.instant(types.software.bspStatus[0].name));
            vm.installUpgradeStatusMessage = null
            vm.isInProgress = false
        } else {
            vm.sucessMessage = null
        }
        
       
        var result = $filter('orderBy')(vm.gwGroupGatewaysMap, vm.query.order);
        vm.rowsCount = result.length;
        var startIndex = vm.query.limit * (vm.query.page - 1);
        vm.components = result.slice(startIndex, startIndex + vm.query.limit);
        getOnPageGatewaysSoftwareVersions()
    }

    function getOnPageGatewaysSoftwareVersions() {
        angular.forEach(vm.components, function (gateway) {
            vm.installUpgradeStatusMessage = null;

            gatewayCommandService.executeCommand(
                gateway.gatewayId.id,
                types.softwareCommand.getSoftwareVersions.value,
                {verType: 1}).then((softwareVersions) => {
                    let bspObj = softwareVersions.filter(metric => metric.name === "tektelic-bsp-version")[0]
                    gateway["bspVersion"] = bspObj && bspObj.ver

                    gatewayCommandService.executeCommand(
                        gateway.gatewayId.id,
                        types.softwareCommand.getUpgradableSoftware.value,
                        {}).then((upgradableSoftware) => {
                            let bspNewObj = upgradableSoftware.filter(metric => metric.name === "tektelic-bsp-version")[0]
                            let newVer = bspNewObj && bspNewObj.newVer;
                            gateway["bspNewVersion"] = newVer;

                            if (!gateway["bspNewVersion"]) {
                                gateway["bspNewVersion"] = gateway["bspVersion"]
                            }

                            let status = getBspUpgradeStatus(gateway)

                            if(!newVer) {
                                gateway["bspNewVersion"] = ''
                            }
                            gateway["bspUpgradeStatus"] = status.bspUpgradeStatus;
                            gateway["hasUpdate"] = status.hasUpdate;

                        },
                        (rejection) => {
                            gateway["bspUpgradeStatus"] = rejection.data;
                            gateway["hasUpdate"] = false;
                            gateway["bspNewVersion"] = '';
                        }
                    );

                },
                (rejection) => {
                    gateway["bspUpgradeStatus"] = rejection.data;
                    gateway["hasUpdate"] = false;
                    gateway["bspVersion"] = '';
                })
        })

    }

    function poolInstallUpgradeStatus(poolInterval, isBspUpgrade, gatewayId) {
        $timeout(() => {
            var result;
            result = getLastUpgradeInstallStatus(gatewayId);
            result.then((pooledResult) => {
                    if (angular.isUndefined(pooledResult.statusCode)) {
                        if (vm.bspUpgradeInProgress > 0) {
                            vm.bspUpgradeInProgress--;
                            updateInstallUpgradeMessage($translate.instant('software.bsp-status-bsp-upgrade-busy'));
                            poolInstallUpgradeStatus(poolInterval, isBspUpgrade, gatewayId);
                        } else {
                            updateInstallUpgradeMessage($translate.instant('software.bsp-status-unknown', {bspStatus: $translate.instant('error.unknown-error')}))
                        }
                    } else if (pooledResult.statusCode === 90000 || pooledResult.statusCode === 90001) {
                        updateInstallUpgradeMessage(pooledResult.msg);
                        let currentGateway = vm.gwGroupGatewaysMap.filter((g) => g.gatewayId.id === gatewayId)[0]
                        currentGateway["bspUpgradeStatus"] = "Upgrade in progress"
                        poolInstallUpgradeStatus(poolInterval, isBspUpgrade, gatewayId);
                    } else {
                        if (pooledResult.statusCode === 0) {
                            gatewayCommandService.executeCommand(gatewayId,
                                types.softwareCommand.getBspStatus.value, {}).then(
                                (bspStatus) => {

                                    if (bspStatus === 90000 || bspStatus === 90001) {
                                        let currentGateway = vm.gwGroupGatewaysMap.filter((g) => g.gatewayId.id === gatewayId)[0]
                                        currentGateway["bspUpgradeStatus"] = "Upgrade in progress"
                                        poolInstallUpgradeStatus(poolInterval, isBspUpgrade, gatewayId);
                                    } else {
                                    gatewayCommandService.executeCommand(
                                        gatewayId,
                                        types.softwareCommand.getSoftwareVersions.value,
                                        {verType: 1}
                                        ).then((softwareVersions) => {
                                        let bspObj = softwareVersions.filter(metric => metric.name === "tektelic-bsp-version")[0]
                                        let currentVersion = bspObj && bspObj.ver
                                        let currentGateway = vm.gwGroupGatewaysMap.filter((g) => g.gatewayId.id === gatewayId)[0]
                                        currentGateway.bspVersion = currentVersion
                                        let status = getBspUpgradeStatus(currentGateway)
                                        currentGateway["bspUpgradeStatus"] = status.bspUpgradeStatus
                                        currentGateway["hasUpdate"] = status.hasUpdate
                                        currentGateway["bspNewVersion"] = '';
                                        updateComponents()
                                        })
                                    }
                                },
                                (rejection) => {
                                    updateInstallUpgradeMessage(rejection.data);
                                }
                            );
                        } else {
                            var bspStatusType = types.software.bspStatus[pooledResult.statusCode];
                            updateInstallUpgradeMessage($translate.instant(bspStatusType.name));
                        }
                    }
                },
                () => {
                    if (vm.bspUpgradeInProgress > 0) {
                        vm.bspUpgradeInProgress--;
                        updateInstallUpgradeMessage($translate.instant('software.bsp-status-bsp-upgrade-busy'));
                        poolInstallUpgradeStatus(poolInterval, isBspUpgrade, gatewayId);
                    } else {
                        vm.installUpgradeStatusMessage = null;
                        vm.bspUpgradeInProgress = 0;
                    }
                });
        }, poolInterval);
    }

    function getLastUpgradeInstallStatus(gatewayId) {
        var deferred = $q.defer();
        var swComponentsPromise = gatewayCommandService.executeCommand(gatewayId,
            types.softwareCommand.getLastInstallUpgradeStatus.value, {});
        swComponentsPromise.then(
            (response) => {
                var statusDescription;
                var statusResponse;
                if (response) {
                    // var statusType = response.lastOperation;
                    var statusTypeMessage = types.software.upgradeStatus[response.lastStatus];

                    if (angular.isDefined(statusTypeMessage)) {
                        statusDescription = $translate.instant(statusTypeMessage.name);
                    } else {
                        statusDescription = $translate.instant('software.upgrade-status-unknown', {upgradeStatus: response});
                    }

                    statusResponse  = response.lastStatus;
                } else {
                    statusDescription = $translate.instant('software.upgrade-status-unknown', {upgradeStatus: response});
                }

                deferred.resolve({
                    msg: statusDescription,
                    statusCode: statusResponse
                });
            },
            () => {
                deferred.reject();
            }
        );
        return deferred.promise;
    }

    function updateInstallUpgradeMessage(message) {
        vm.installUpgradeStatusMessage = $translate.instant('software.upgrade-status', {upgradeStatus: message});
    }

    function updateSuccessMessage(message) {
        vm.sucessMessage = $translate.instant('software.upgrade-status', {upgradeStatus: message});
    }
}



// WEBPACK FOOTER //
// ./src/app/gateway-group/software/gw-group-sw-management.directive.js